import { useEffect, useState } from 'react'
import { Survey } from '../../../types/survey'
import { shouldFetchSurvey } from './shoulFetchSurvey'
import { getSurvey } from '../../../store/async-thunks/homePage/getSurvey'

export function useSurvey(autoLoad: boolean = true) {
    const [survey, setSurvey] = useState<Survey | null>(null)
    const [loading, setLoading] = useState(autoLoad)
    const [error, setError] = useState(null)
    const shouldFetch = shouldFetchSurvey()

    const nullifySurvey = () => {
        setSurvey((_) => null)
    }

    const loadSurvey = async () => {
        setLoading(true)
        setError(null)
        try {
            const data = await getSurvey()
            setSurvey(data)
        } catch (err) {
            setError(err)
        } finally {
            setLoading(false)
        }
    }

    useEffect(() => {
        if (autoLoad && shouldFetch) {
            loadSurvey().then(console.log)
        }
    }, [autoLoad, shouldFetch])

    return {
        survey,
        loading,
        error,
        reload: loadSurvey,
        nullifySurvey,
    }
}